<template>
  <div>
    <input type="text" 
      :placeholder="$t('Mi búsqueda')"
      @keyup="getData" 
      v-model="search" 
      @blur="hideResults(0)" 
      @focus="showResults"
      @keyup.enter="submitSearch"      
      ><button @click="submitSearch" type="submit" class="btn btn-primary btn-xs btn-search"><i v-if="!loading" class="fa fa-search"></i><img v-else src="@/assets/img/loading-mini-white.gif" alt="Loading"></button>
      <div v-if=" (terms && showSearchResults) || isISBN " class="search-results">
        <template v-if=" isISBN && search.trim().length >= isbnShow && search.trim().length <= 13 ">
          <div class="search-results-row">
            <!-- <div class="stable">
              <div class="srow">
                <div class="scell box indice">I</div>
                <div class="scell result-term">{{ search }}<template v-for=" i in ( 13 - search.length ) "><span class="red">X</span></template><span class="result-type">ISBN / Código</span>
                </div>
                <div class="scell results"></div>
              </div>
            </div> -->
            <div class="stable">
              <div class="srow">          
                <div class="scell result-term">
                  {{ $t('Para completar un ISBN/Código EAN faltan') + ' ' + ( 13 - search.trim().length ) + ' ' + $t('dígitos') }}</div>
              </div>
            </div>
          </div>
        </template>   
        <div v-else v-for="term in terms" :key="term.ID" class="search-results-row">
          <router-link
            :to="{ name: 'catalogo', params: { idioma: getLocale, category: term.CATEGORIA }, query: getQueryString(term.QUERY, term.ID_TERM, term.RESULTADO) }" 
            @click.native="hideResults(1)">
            <div class="stable">
              <div class="srow">
                <div :class="'scell box '+ term.CATEGORIA">{{ term.CAT }}</div>
                <div class="scell result-term">{{ term.RESULTADO }}<span class="result-type">{{ term.TIPO }}</span></div>
                <div class="scell results">{{ term.CANTIDAD }}</div>
              </div>
            </div>
          </router-link>
        </div>
      </div>
      <!-- <pre>{{ terms }}</pre> -->
  </div>
</template>

<i18n>
{
  "es": {
    "Mi búsqueda": "Mi búsqueda",
    "Para completar un ISBN/Código faltan": "Para completar un ISBN/Código faltan",
    "dígitos": "dígitos"
  },
  "en": {
    "Mi búsqueda": "My search",
    "Para completar un ISBN/Código faltan": "To complete an ISBN/Código there are missing",
    "dígitos": "digits"
  },
  "ca": {
    "Mi búsqueda": "La meva cerca",
    "Para completar un ISBN/Código faltan": "Per completar un ISBN/Código falten",
    "dígitos": "dígits"
  }
}
</i18n>

<script>
  import axios from 'axios';  
  import {mapMutations, mapGetters} from 'vuex';

	export default {
		data: () => {
			return{
        terms: false,     // Response
        search: '',       // Search term
        cancelToken: '',
        source: '',
        showSearchResults: true,
        timeout: null,
        isbnShow: 8,
        isISBN: false,
        loading: false
			}
		},
    computed: mapGetters(['getLocale', 'getApiUrl']),
    methods: {
      getData(){
        if(this.search.trim().length>=1){
          let isNum = /^\d+$/.test(this.search.trim());
          if( this.search.trim().length >= this.isbnShow && isNum )  {
            this.isISBN = true;
          }else{
            this.isISBN = false;
            clearTimeout(this.timeout);
            this.timeout = setTimeout(function() {
              if(this.cancelToken!='' && this.source!=''){
                this.source.cancel();   
              }
              this.cancelToken = axios.CancelToken;
              this.source = this.cancelToken.source();

              this.loading = true
              axios.get( this.getApiUrl + this.getLocale + '/busqueda/'+ encodeURIComponent(this.search.trim()), {cancelToken: this.source.token}).then(response => {
                  this.terms = response.data.data; 
                  //console.log(response.data.data)
                   this.loading = false
              }).catch((thrown) => {
                if (axios.isCancel(thrown)) {
                  //console.log('Request canceled');
                  this.loading = false
                } else {
                  this.terms = [];
                   this.loading = false
                }
              });

            }.bind(this), 300);
          }
        }  
      },
      getQueryString(varName, varID, varValue ){
        /*if( varName != 'TITULO' && varName != 'C_TITULO_ORIGINAL' ){ varValue = varID; }
        return JSON.parse('{ "'+varName+'": "'+varValue+'" }');*/
        let obj = {};
        obj[varName] = varValue;
        obj['ref'] = 'buscador';
        //return JSON.parse('{ "'+varName+'": "'+varValue+'" }');
        return obj;
      },
      submitSearch(){
        document.activeElement.blur();
        if(this.isISBN){
          this.$router.push({ name: 'catalogo', params: { language: this.getLocale, category: 'indice' }, query: { CODIGO: this.search.trim(), ref: 'buscador' } });
        }else{
          this.$router.push({ name: 'catalogo', params: { language: this.getLocale, category: 'indice' }, query: { TITULO: this.search.trim(), ref: 'buscador' } });
        }
      },
      showResults(){ this.showSearchResults = true; },
      hideResults(tmp){
        if(tmp){
          this.showSearchResults = false;
        }else{
          setTimeout(() => {
            this.showSearchResults = false;
          }, 300);
        }
      },
    },
    watch: {
    }
  }
</script>
<style scoped>
  .btn-search{
    width: 39px !important;
  }
</style>
